export default "__VITE_ASSET__140b3ed8__"